import { OneColumn } from 'components/page';
import { BiGrid } from 'pages/bi/components/list/BiGrid';

export function BiListComp() {
    return (
        <OneColumn title="Configuração de Painéis de BI" createButton goBackButton>
            <BiGrid />
        </OneColumn>
    );
}
